import { useMutation } from "@apollo/client";

import {
  DeleteLocationMutation,
  DeleteLocationMutationVariables,
} from "../../../../../API";
import { useCustomerIdGuard } from "../../../../../common/hooks/useCustomerIdGuard";
import { DELETE_LOCATION } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useDeleteLocation = (name: string) => {
  const selectedCustomerId = useCustomerIdGuard();

  const [deleteLocationMutation, { data, loading }] = useMutation<
    DeleteLocationMutation,
    DeleteLocationMutationVariables
  >(DELETE_LOCATION);

  const deleteLocation = async (id: string) => {
    return await deleteLocationMutation({
      variables: {
        customerId: selectedCustomerId,
        locationId: id,
      },
      onCompleted: response => {
        if (response.deleteLocation) {
          successNotification(`${name} is deleted`);
        }
      },
      onError: handleApolloError,
      update(cache) {
        const normalizedId = cache.identify({ id, __typename: "Location" });

        cache.evict({ id: normalizedId });

        cache.gc();
      },
    });
  };

  return { deleteLocation, data, loading };
};
